"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METHODS = void 0;
exports.METHODS = {
    getEnvInfo: 'getEnvInfo',
    sendTransactions: 'sendTransactions',
    rpcCall: 'rpcCall',
    getSafeInfo: 'getSafeInfo',
};
//# sourceMappingURL=methods.js.map